export const MAX_CHARACTER_DEFAULT_LENGTH = 255;

export const ADMIN_ENTITLED_FEATURE_KEYS = {
  DOCS_BASE: 'DOCBASE',
  BUILD_ESSENTIALS: 'ACCBDESN'
} as const;

export const LOCAL_STORAGE_KEYS = {
  CDE_VALIDATOR_SUBMIT_HOLDING_AREA: 'cdeValidatorSubmitHoldingArea',
  CDE_VALIDATOR_AUTOFILL_METADATA: 'cdeValidatorAutofillMetadata',
  VALIDATOR_COLUMN_WIDTH: 'validatorColumnWidth'
} as const;

export const TDF_RULES = {
  FDM_HELP_LINK: 'application:aec:docs:file-system:fdm-help-navigate'
} as const;
